import { Injectable, Injector, OnDestroy, OnInit } from '@angular/core';
import { CurrencyModel } from '../models/currency.model';
import { ApiInterface, ApiService } from '../../api/api.service';
import { SettingService } from '../../settings/services/setting.service';

@Injectable()
export class CurrencyService extends ApiService implements OnInit, OnDestroy, ApiInterface {

    public restEndpoint = 'currencies';

    protected cache = true;

    protected cacheExpire = 600;

    public model = CurrencyModel;

    protected settingService: SettingService;

    /**
     * Constructor.
     *
     * @param injector
     */
    constructor(injector: Injector) {
        super(injector);

        this.settingService = this.injector.get(SettingService);
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    public getDefaultCurrency(): CurrencyModel {
        const defaultCurrency = this.settingService.mapped['general.currency.currency'] || 'EUR';

        return this.cachedData.all().find(currency => currency.code.toUpperCase() === defaultCurrency.toUpperCase());
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/currency/services/currency.service.ts